import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PropertyProvider } from './context/PropertyContext';
import { SubscriptionProvider } from './context/SubscriptionContext';
import FormPage from './FormPage';
import AutocompletePage from './AutocompletePage';
import SubscriptionPage from './pages/SubscriptionPage';
import PortfolioPage from './pages/PortfolioPage';
import SearchHistoryPage from './pages/SearchHistoryPage';
import BrowsePropertiesPage from './pages/BrowsePropertiesPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactPage from './pages/ContactPage';
import Login from './components/Login';
import Signup from './components/Signup';
import EmailVerification from './components/EmailVerification';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import './config/cognito';
import './App.css';

// Inner App component that has access to auth context
const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();
  const isLoginOnlyMode = process.env.REACT_APP_LOGIN_ONLY_MODE === 'true';

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        Loading...
      </div>
    );
  }

  // Login-only mode: show only login for unauthenticated users
  if (isLoginOnlyMode && !isAuthenticated) {
    return (
      <div className="app-container">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh',
          flexDirection: 'column'
        }}>
          <Login />
        </div>
      </div>
    );
  }

  // Normal app functionality for authenticated users or when login-only mode is off
  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<AutocompletePage />} />
          <Route path="/login" element={<Login />} />
          {!isLoginOnlyMode && <Route path="/signup" element={<Signup />} />}
          {!isLoginOnlyMode && <Route path="/verify-email" element={<EmailVerification />} />}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/form" element={<FormPage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/search-history" element={<SearchHistoryPage />} />
          <Route path="/browse" element={<BrowsePropertiesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <PropertyProvider>
          <AppContent />
        </PropertyProvider>
      </SubscriptionProvider>
    </AuthProvider>
  );
};

export default App;
